import OrbitAvatar from '@/components/OrbitAvatar'
import OSlateEditor from '@/libs/slate-editor'
import { createTaskComment, deleteTask, editTask, getTaskComments } from '@/services/task/task'
import { selectUser } from '@/store/user/user.slice'
import { useRequest } from 'ahooks'
import { Card, Dropdown, Menu, Button, Row, Form } from 'antd'
import dayjs from 'dayjs'
import { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import styles from './index.module.less'
import { Comment } from '@ant-design/compatible';

const TaskComments = memo((props: any) => {
  const { task, members, updateTask } = props
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const userInfo = useSelector(selectUser).userInfo!
  const memberData = useMemo(() => members.find((item) => item.id === userInfo.id), [members, userInfo])!
  const { data: comments = [], refresh: refreshComments } = useRequest(() => getTaskComments(task.id))
  const { run: runCreateComment, loading: commentLoading } = useRequest(
    (body) => createTaskComment(task.id, { ...body, memberId: memberData?.memberId }),
    {
      manual: true,
      onSuccess: () => {
        refreshComments()
        form.resetFields()
      }
    }
  )

  return (
    <>
      {!!comments.length && (
        <div className={styles.comments}>
          {comments.map((comment) => (
            <Comment
              key={comment.id}
              avatar={<OrbitAvatar avatar={comment.member?.avatar} name={comment.member?.fullName} />}
              content={
                <Card
                  title={
                    <span>
                      <strong>{comment.member?.fullName}</strong> commented {dayjs(comment.createTime).fromNow()}
                    </span>
                  }
                  size='small'
                  extra={''}
                >
                  <OSlateEditor value={comment.content} readOnly={true} />
                </Card>
              }
            />
          ))}
        </div>
      )}

      <div className={styles.addComment}>
        <h5>comment</h5>
        <Comment
          className={styles.commentEditor}
          avatar={<OrbitAvatar avatar={memberData?.avatar} name={memberData?.fullName} />}
          content={
            <Form
              form={form}
              onFinish={(values) => {
                runCreateComment(values)
              }}
            >
              <Form.Item name='content' rules={[{ required: true, message: 'Please enter terms content' }]}>
                <OSlateEditor />
              </Form.Item>

              <Row justify={'end'}>
                <Dropdown.Button
                  onClick={async () => {
                    const data = await editTask(task.id, { status: task.status === 'CLOSED' ? 'OPEN' : 'CLOSED' })
                    updateTask(data)
                  }}
                  placement='topRight'
                  overlay={
                    <Menu
                      onClick={async ({ key }) => {
                        if (key === 'remove') {
                          await deleteTask(task.id)
                          navigate('../')
                        }
                      }}
                      items={[
                        {
                          label: 'Remove task',
                          key: 'remove',
                          danger: true
                        }
                      ]}
                    />
                  }
                >
                  {task.status === 'CLOSED' ? 'Reopen' : 'Close'}
                </Dropdown.Button>
                <Button className={'ml-1'} type='primary' htmlType='submit' loading={commentLoading}>
                  Comment
                </Button>
              </Row>
            </Form>
          }
        />
      </div>
    </>
  )
})

export default TaskComments
